import Controller, { OnMount, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import { PanelAPI, TabControlAPI, TabWithContentAPI } from '@philips-internal/oswald-ui-components';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';

import { Inject } from '@odinjs/odin';

import BaseController from '../../BaseController';
import InformationBarUtils from '../../commons/header/information-bar-header-utils';
import { FragmentNames, HealthHistoryListAliases } from '../../../codegen';
import { HealthHistoryListContext } from '../service/health-history-list-service';
import { HealthHistoryType } from '../health-history-types';
import HealthHistoryCommons from '../health-history-commons';

@Controller({ component: HealthHistoryListAliases.LAYOUT_HEALTH_HISTORY, fragment: FragmentNames.HEALTH_HISTORY_LIST })
export default class HealthHistpryListController extends BaseController {

  @Inject(HealthHistoryListAliases.PANEL_TAB_CONTROL)
  private panelTabControlAPI!: PanelAPI;

  @Inject(HealthHistoryListAliases.TAB_CONTROL)
  private tabControlAPI!: TabControlAPI;

  @OnMount({ target: HealthHistoryListAliases.LAYOUT_HEALTH_HISTORY })
  handleMount(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    InformationBarUtils.collapsedBar = true;
    this.context.set({ encounterId, patientId });
    HealthHistoryCommons.checkHealthHisotryEditPermission()
      .finally(() => {
        this.panelTabControlAPI.setVisible(true);
      });
  }

  @OnMount({ target: HealthHistoryListAliases.TAB_CONTROL })
  handleMountTabControl(): void {
    const currentTab = HealthHistoryListContext.currentTab;
    this.tabControlAPI.setActiveTab(!currentTab ? HealthHistoryType.ALLERGIES : currentTab);
    HealthHistoryListContext.currentTab = this.tabControlAPI.getActiveTab()
  }

  @OnMount({ target: HealthHistoryListAliases.TAB_WITH_CONTENT_ALLERGY })
  handleMountTabWithContentAllergy(event: MountEvent): void {
    const tabApi = event.target as TabWithContentAPI;
    this.activeTab(tabApi, HealthHistoryType.ALLERGIES);
  }

  @OnMount({ target: HealthHistoryListAliases.TAB_WITH_CONTENT_DISEASES })
  handleMountTabWithContentDiseases(event: MountEvent): void {
    const tabApi = event.target as TabWithContentAPI;
    this.activeTab(tabApi, HealthHistoryType.DISEASES);
    HealthHistoryListContext.clean();
  }

  @OnMount({ target: HealthHistoryListAliases.TAB_WITH_CONTENT_SOCIAL_HISTORY })
  handleMountTabWithContentSocialHistory(event: MountEvent): void {
    const tabApi = event.target as TabWithContentAPI;
    this.activeTab(tabApi, HealthHistoryType.SOCIAL_HISTORY);
  }

  @OnMount({ target: HealthHistoryListAliases.TAB_WITH_CONTENT_MEDICINES })
  handleMountTabWithContentMedications(event: MountEvent): void {
    const tabApi = event.target as TabWithContentAPI;
    this.activeTab(tabApi, HealthHistoryType.MEDICINES);
  }

  @OnUnmount({ target: HealthHistoryListAliases.LAYOUT_HEALTH_HISTORY })
  handleUnmountRoot(): void {
    HealthHistoryListContext.clean()
  }

  private activeTab(tab: TabWithContentAPI, idHealthHistory: string): void {
    tab.setVisible(true);
    tab.setActiveTab(idHealthHistory)
  }
}
